"use client";

import { Zoom } from "@/components/ui/animations/zoom";
import { Shell } from "@/components/ui/shell";
import { convertKeysToCamelCase } from "@/lib/utils";
import { PersonalityProps, WallOfFameSectionProps } from "@/services/home/types";

import { Winners } from "./winners";
import Carpet from "@/components/ui/Carpet";
import RotatingTrophyVideo from "../RotatingTrophy";

type Props = {
  data: WallOfFameSectionProps;
};

export default function WallOfFame({ data: res }: Readonly<Props>) {
  const data = convertKeysToCamelCase(res);
  const personalities = data.personalities?.map((x) =>
    convertKeysToCamelCase(x)
  ) as unknown as PersonalityProps[];

  return (
    <Carpet type="fade-light" className="pt-8">
      <Shell className="!pt-0">
        <div className="flex h-full justify-center 2xl:justify-between">
          <div className="flex flex-col items-start gap-8 pt-6 xs:items-center xs:gap-20 xs:text-center lg:gap-40 2xl:flex-row 2xl:justify-between">
            <div className="flex h-full flex-col-reverse items-center justify-start gap-10 xs:text-center lg:gap-14 xl:gap-20 2xl:flex-col 3xl:gap-32">
              <div className="se flex flex-col gap-6">
                <h1 className="text-[40px] text-secondary xs:text-[50px] lg:text-[60px] xl:text-[70px] 2xl:text-left 3xl:text-[90px] ltr:font-playfair">
                  {data?.title}
                </h1>
                <p className="max-w-[518px] text-balance text-lg text-[#FFF4E3] 2xl:text-left 2xl:text-2xl 2xl:leading-[39.84px] ltr:font-opensans">
                  {data?.description}
                </p>
              </div>

              <Zoom duration={0.6} delay={0.2}>
                <RotatingTrophyVideo />
              </Zoom>
            </div>
            <Winners data={personalities ?? []} />
          </div>
        </div>
      </Shell>
    </Carpet>
  );
}
